module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "h-6 w-6 stroke-current fill-current text-blue-dark",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 60 60"
    }
  }, [_c('path', {
    attrs: {
      "d": "M38.914 0H6.5v60h47V14.586L38.914 0zm.586 3.414L50.086 14H39.5V3.414zM8.5 58V2h29v14h14v42h-43z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M42.5 21h-16a1 1 0 1 0 0 2h16a1 1 0 1 0 0-2zM22.875 18.219l-4.301 3.441-1.367-1.367a.999.999 0 1 0-1.414 1.414l2 2a.998.998 0 0 0 1.331.074l5-4a1 1 0 0 0-1.249-1.562zM42.5 32h-16a1 1 0 1 0 0 2h16a1 1 0 1 0 0-2zM22.875 29.219l-4.301 3.441-1.367-1.367a.999.999 0 1 0-1.414 1.414l2 2a.998.998 0 0 0 1.331.074l5-4a1 1 0 0 0-1.249-1.562zM42.5 43h-16a1 1 0 1 0 0 2h16a1 1 0 1 0 0-2zM22.875 40.219l-4.301 3.441-1.367-1.367a.999.999 0 1 0-1.414 1.414l2 2a.998.998 0 0 0 1.331.074l5-4a1 1 0 0 0-1.249-1.562z"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ad1c5372","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/navbar/sidemenu/svgs/TasksSVG.vue
// module id = 617
// module chunks = 66